import React, { useState, useEffect } from 'react';
import { Save, MapPin, Phone, Mail, Instagram, Facebook, MessageCircle, Clock } from 'lucide-react';
import './AdminSettings.css';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function AdminSettings() {
  const [settings, setSettings] = useState({
    salon_name: '',
    address: '',
    phone: '',
    email: '',
    instagram: '',
    facebook: '',
    whatsapp: '',
    opening_hours: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const password = sessionStorage.getItem('admin_password') || '';

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await fetch(`${API_URL}/api/settings`);
      const data = await response.json();
      setSettings(data);
      setLoading(false);
    } catch (e) {
      console.error('Erro ao carregar configurações:', e);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');

    try {
      console.log('Enviando dados:', settings);
      console.log('URL:', `${API_URL}/api/admin/settings`);
      console.log('Password:', password);
      
      const response = await fetch(`${API_URL}/api/admin/settings`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-adminpassword': password
        },
        body: JSON.stringify(settings)
      });
      
      console.log('Response status:', response.status);
      console.log('Response headers:', [...response.headers]);
      
      const responseText = await response.text();
      console.log('Response text:', responseText);
      
      if (!response.ok) {
        throw new Error(`Erro ${response.status}: ${responseText}`);
      }
      
      const data = JSON.parse(responseText);
      setSettings(data);
      setMessage('Configurações salvas com sucesso!');
      setTimeout(() => setMessage(''), 3000);
    } catch (e) {
      console.error('Erro completo:', e);
      setMessage(`Erro: ${e.message}`);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="admin-loading">Carregando...</div>;

  return (
    <div className="admin-settings">
      <div className="admin-header">
        <h1>⚙️ Configurações do Salão</h1>
        <p>Edite as informações de contato e redes sociais</p>
      </div>

      {message && (
        <div className={`message ${message.includes('sucesso') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="settings-form">
        <div className="form-section">
          <h3><MapPin size={18} /> Informações Gerais</h3>
          
          <div className="form-group">
            <label>Nome do Salão</label>
            <input
              type="text"
              name="salon_name"
              value={settings.salon_name || ''}
              onChange={handleChange}
              placeholder="Patricia Pourroy Studio"
            />
          </div>

          <div className="form-group">
            <label>Endereço Completo</label>
            <textarea
              name="address"
              value={settings.address || ''}
              onChange={handleChange}
              placeholder="Rua, número, bairro, cidade"
              rows="2"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label><Phone size={16} /> Telefone</label>
              <input
                type="text"
                name="phone"
                value={settings.phone || ''}
                onChange={handleChange}
                placeholder="(11) 99999-9999"
              />
            </div>

            <div className="form-group">
              <label><Mail size={16} /> E-mail</label>
              <input
                type="email"
                name="email"
                value={settings.email || ''}
                onChange={handleChange}
                placeholder="contato@email.com"
              />
            </div>
          </div>

          <div className="form-group">
            <label><Clock size={16} /> Horário de Funcionamento</label>
            <input
              type="text"
              name="opening_hours"
              value={settings.opening_hours || ''}
              onChange={handleChange}
              placeholder="Segunda a Sábado: 9h às 19h"
            />
          </div>
        </div>

        <div className="form-section">
          <h3>📱 Redes Sociais</h3>
          
          <div className="form-group">
            <label><Instagram size={16} /> Instagram</label>
            <input
              type="text"
              name="instagram"
              value={settings.instagram || ''}
              onChange={handleChange}
              placeholder="@patriciapourroystudio"
            />
          </div>

          <div className="form-group">
            <label><Facebook size={16} /> Facebook</label>
            <input
              type="text"
              name="facebook"
              value={settings.facebook || ''}
              onChange={handleChange}
              placeholder="facebook.com/patriciapourroystudio"
            />
          </div>

          <div className="form-group">
            <label><MessageCircle size={16} /> WhatsApp</label>
            <input
              type="text"
              name="whatsapp"
              value={settings.whatsapp || ''}
              onChange={handleChange}
              placeholder="(11) 99999-9999"
            />
          </div>
        </div>

        <button 
          type="submit" 
          className="btn-save"
          disabled={saving}
        >
          <Save size={18} />
          {saving ? 'Salvando...' : 'Salvar Configurações'}
        </button>
      </form>
    </div>
  );
}
